import moment from 'moment';

const parseDate = date => ({
  hour: moment(date).hour(),
  minute: moment(date).minute(),
  day: moment(date).date(),
  month: moment(date).month(),
  year: moment(date).year(),
});

const getSessionTitle = ({ trainingModuleName, trainingModuleCode, trainingPartCode }) => {
  const moduleLabel = trainingModuleName || trainingModuleCode || '';
  const partLabel = trainingPartCode || '';

  return [moduleLabel, partLabel].filter(Boolean).join(' · ');
};

const isValidDateTime = (date, time) => {
  if (!date || !time) {
    return false;
  }

  return (
    moment(date, ['YYYY-MM-DD', 'DD.MM.YYYY', moment.ISO_8601], true).isValid() &&
    moment(`${date} ${time}`, ['YYYY-MM-DD HH:mm', 'DD.MM.YYYY HH:mm', moment.ISO_8601], true).isValid()
  );
};

const transformToSchedulerDataDaily = data => {
  const transformedData = [];

  if (Array.isArray(data)) {
    data.forEach(item => {
      const { startTime, endTime, startDate, endDate, deliveryMethod, id, description } = item;
      if (!isValidDateTime(startDate, startTime) || !isValidDateTime(endDate, endTime)) {
        return;
      }

      const { hour: startHour, minute: startMinute } = parseDate(`${startDate} ${startTime}`);
      const { hour: endHour, minute: endMinute } = parseDate(`${endDate} ${endTime}`);
      const startMoment = moment(startDate);
      const endMoment = moment(endDate);
      const title = getSessionTitle(item);

      if (!startMoment.isValid() || !endMoment.isValid()) {
        return;
      }

      const dateDifference = Math.max(endMoment.diff(startMoment, 'days'), 0);

      for (let dayOffset = 0; dayOffset <= dateDifference; dayOffset += 1) {
        const newDate = moment(startMoment).add(dayOffset, 'd');
        const { year: newDateYear, month: newDateMonth, day: newDateDay } = parseDate(newDate);
        transformedData.push({
          id,
          type: deliveryMethod,
          desc: description,
          title,
          sessionInfo: item,
          start: new Date(
            moment().year(newDateYear).month(newDateMonth).date(newDateDay).hour(startHour).minute(startMinute),
          ),
          end: new Date(
            moment().year(newDateYear).month(newDateMonth).date(newDateDay).hour(endHour).minute(endMinute),
          ),
        });
      }
    });
  }

  return transformedData;
};

export default transformToSchedulerDataDaily;
